export default __webpack_public_path__ + "static/media/youtube.c5c5fffa.svg";